import {
  ADD_TEAM_REQUEST,
  ADD_TEAM_SUCCESS,
  ADD_TEAM_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
import { toast } from "react-toastify";
//action that returns a promise
export const AddTeamAction = (data, navigate) => {
  return function (dispatch) {
    return new Promise((resolve, reject) => {
      dispatch({
        type: ADD_TEAM_REQUEST,
        payload: true,
      });

      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/add_team_member`,
        method: "POST",
        data: data,
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(CreateJobFormPre(res.data, navigate));
          resolve(res.data);
        })
        .catch((error) => {
          console.log('Error----', error?.response?.data?.status?.message);

          dispatch({
            type: ADD_TEAM_FAIL,
            payload: false,
            error: error,
            createJob: error.success,
            msg: "Failed to create user registration",
          });
          toast.error(
            error?.response?.data?.status?.message
              ? error?.response?.data?.status?.message
              : "Failed "
          );
          reject(error);
        });
    });
  };
};

export const CreateJobFormPre = (data, navigate) => {
  if(data?.data?.statusCodeValue !== 400){
  toast.success(data.data.body);

  setTimeout(()=>{
      navigate("/team-list");
  },2000)

  }
  
  return {
    type: ADD_TEAM_SUCCESS,
    createJob: data.status.message,
    result: data,
    payload: false,
    msg: data.status.message,
  };
};
